import { InMemoryCache } from "@apollo/client";
import { relayStylePagination } from "@apollo/client/utilities";
import { merge } from "lodash";

// Create inMemoryCache
export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        paginatedTenders: {
          keyArgs: ["sort"],
        },
        paginatedUsers: relayStylePagination(),
        paginatedOrganizations: relayStylePagination(),
        paginatedConfigAdministrators: relayStylePagination(),
        paginatedTariffs: relayStylePagination(),
        paginatedHolidays: relayStylePagination(),
        paginatedChristmasBonus: relayStylePagination(),
        paginatedVacationBonus: relayStylePagination(),
        paginatedVacationDays: relayStylePagination(),
        paginatedLiabilityInsurance: relayStylePagination(),
        paginatedSocialSecurity: relayStylePagination(),
        paginatedMainOrganizationsWithHierarchy: relayStylePagination(),
        fetchNotifications: {
          merge(existing, incoming) {
            return merge({}, existing, incoming);
          },
        },
      },
    },
  },
});
